import { AuthServerProvider } from "../shared/auth/auth.service";
import { of } from "rxjs/observable/of";
import { Auth401Service } from "../shared/auth/auth401.service";
import { catchError } from "rxjs/operators";

export function configure(module: ng.IModule) {
    module.run(configureBreeze);

    configureBreeze.$inject = ["breeze", "authServerProvider", "$state", "auth401Service"];
}

export var breezeInstance;
declare var OData: any;

export function configureBreeze(
    breeze,
    authServerProvider: AuthServerProvider,
    $state: ng.ui.IStateService,
    auth401Service: Auth401Service) {
    breeze.config.initializeAdapterInstance("dataService", "webApiOData", true);

    // See http://stackoverflow.com/questions/26554218/cant-save-the-data-to-odata-controller-after-updating-to-microsoft-aspnet-webap
    var adapter: any = breeze.config.getAdapterInstance("dataservice", "webApiOData");

    adapter.getRoutePrefix = getRoutePrefix531; // plug-in alternative for THIS adapter instance.

    var httpClient = OData.defaultHttpClient;

    var getErrorHandler = function (retryRequest: (newJwtToken: string) => any, baseErrorHandler: (error: any) => any, jwtToken: string) {
        return (error) => {
            if (error.response && error.response.statusCode === 401) {
                auth401Service
                    .handle401Error(newJwtToken => of(retryRequest(newJwtToken)), error, !!jwtToken, () => jwtToken)
                    .pipe(catchError(err => {
                        try {
                            baseErrorHandler(err);
                        } catch (e) {

                        }
                        $state.go("app.home");
                        return of({});
                    }))
                    .subscribe();
            }
            else {
                baseErrorHandler(error);
            }
        };
    }

    var getRequestHandler = (request, success, error) => {

        const getRequestHandlerForJwtToken = (jwtToken: string) => {
            if (jwtToken) {
                request.headers.Authorization = 'Bearer ' + jwtToken;
            }

            return httpClient.request(request, success, getErrorHandler(getRequestHandlerForJwtToken, error, jwtToken));
        }

        return getRequestHandlerForJwtToken;
    }

    var httpClientWithAuthHeader = {
        request: function(request, success, error) {
            return getRequestHandler(request, success, error)(authServerProvider.getToken());
        }
    };

    OData.defaultHttpClient = httpClientWithAuthHeader;

    function getRoutePrefix531(dataService) {
        // Copied from breeze.debug and modified for Web API OData v.5.3.1.
        if (typeof document === 'object') { // browser
            var parser = document.createElement('a');
            parser.href = dataService.serviceName;
        } //else { // node
        //  parser = url.parse(dataService.serviceName);
        //}
        // THE CHANGE FOR 5.3.1: Add '/' prefix to pathname
        var prefix = parser.pathname;
        if (prefix[0] !== '/') {
            prefix = '/' + prefix;
        } // add leading '/'  (only in IE)
        if (prefix.substr(-1) !== '/') {
            prefix += '/';
        } // ensure trailing '/'
        return prefix;
    };

    breezeInstance = breeze;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/breeze.config.ts